import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, fileUrl } from "../lib/api";

const SiteCtx = createContext(null);

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  const reload = useCallback(async () => {
    const { data } = await api.get("/public/site");
    setSite(data);
    const b = data.branding || {};
    if (b.site_title) document.title = b.site_title;
    const link = document.getElementById("app-favicon");
    if (link) {
      link.removeAttribute("type");
      link.href = b.favicon ? fileUrl(b.favicon) : "/favicon.svg";
    }
  }, []);
  useEffect(() => {
    reload();
  }, [reload]);
  return <SiteCtx.Provider value={{ site, reload }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
export const useContent = (key) => useContext(SiteCtx).site?.content?.[key] || {};
